import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  onDeleteCategory = () => {
    const {
      openRemoveCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.uid;
    openRemoveCategoryModal(uid);
  };

  onEditCategory = () => {
    const {
      openEditCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.categoryUID;
    openEditCategoryModal(uid);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.onEditCategory}>edytuj</a>
              <br />
              <a onTouchTap={this.onDeleteCategory}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

class DataComponent extends Component {
  render() {
    return (
      <span>{moment(new Date(this.props.data)).format("DD.MM.YYYY")}</span>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        pagesLists: {
          pagesLists: {
            search: pagesListsSearch,
            meta: pagesListsMeta,
            sort: pagesListsSort
          }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setPagesListsPaginationPage(0);
      let isDirectionAscending = pagesListsSort.isDirectionAscending;
      if (field === pagesListsSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortPagesLists(field, isDirectionAscending);
      actions
        .getPagesLists(pagesListsMeta, pagesListsSort)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    }
  };

  loadPagesListCategories = () => {
    const {
      actions,
      notificationSystem,
      params: { slug },
      locales: {
        locales: { defaultLocale }
      }
    } = this.props;
    actions.getPagesListCategories(slug).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  };

  openRemoveCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveCategoryModalVisible(uid);
  };

  closeRemoveCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveCategoryModalVisible(false);
  };

  removeCategory = () => {
    const {
      actions,
      categories: {
        categories: { isRemoveModalVisible }
      },
      notificationSystem
    } = this.props;
    actions
      .removeCategoryTranslation(isRemoveModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          this.loadPagesListCategories();
        }
      });
    actions.setIsRemoveCategoryModalVisible(false);
  };

  openEditCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsEditCategoryModalVisible(uid);
  };

  closeEditCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsEditCategoryModalVisible(false);
  };

  updateCategory = () => {
    const {
      actions,
      categories: {
        categories: { isEditModalVisible, entities: categories }
      },
      notificationSystem,
      locales: {
        locales: { defaultLocale }
      }
    } = this.props;
    let data = {
      name: categories.getIn([
        isEditModalVisible,
        "categoryTranslations",
        defaultLocale,
        "name"
      ]),
      tag: categories.getIn([
        isEditModalVisible,
        "categoryTranslations",
        defaultLocale,
        "tag"
      ]),
      description: categories.getIn([
        isEditModalVisible,
        "categoryTranslations",
        defaultLocale,
        "description"
      ])
    };
    const uid = categories.getIn([
      isEditModalVisible,
      "categoryTranslations",
      defaultLocale,
      "uid"
    ]);
    actions.updateCategoryTranslation(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        this.loadPagesListCategories();
      }
    });
    actions.setIsEditCategoryModalVisible(false);
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      pagesLists: {
        pagesLists: {
          loading,
          entities: pagesLists,
          meta: { currentPage, limit },
          sort
        }
      },
      params: { slug },
      locales: {
        locales: { defaultLocale }
      },
      categories: {
        categories: {
          entities: categories,
          isRemoveModalVisible,
          isEditModalVisible
        }
      }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "tag",
        displayName: "Tag",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "description",
        displayName: "Opis",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveCategoryModal: this.openRemoveCategoryModal,
          openEditCategoryModal: this.openEditCategoryModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (pagesLists.getIn([slug, "categories"])) {
      pagesLists.getIn([slug, "categories"]).forEach(function(category) {
        data.categoryUID = category;
        category = categories
          .getIn([category, "categoryTranslations", defaultLocale])
          .toJS();
        index++;
        category.index = index + currentPage * limit;
        data = data.concat(category);
      });
    }

    const inputCustomProps = {
      feature: "categories",
      actions: actions,
      entity: categories.get(isEditModalVisible),
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "tag", "description", "actions"]}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />
        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveCategoryModal}
            enterAction={this.removeCategory}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removeCategory}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeRemoveCategoryModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditCategoryModal}
            enterAction={this.updateCategory}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj kategorię</h3>
              <InputCustom
                field={["categoryTranslations", defaultLocale, "name"]}
                {...inputCustomProps}
              />
              <InputCustom
                field={["categoryTranslations", defaultLocale, "tag"]}
                {...inputCustomProps}
              />
              <InputCustom
                field={["categoryTranslations", defaultLocale, "description"]}
                {...inputCustomProps}
              />
              <button className="error" onTouchTap={this.updateCategory}>
                Tak
              </button>
              <button className="info" onTouchTap={this.closeEditCategoryModal}>
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesListCategories/table.react.js